import { render } from "./BusinessCooperation.vue?vue&type=template&id=07413408&scoped=true"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js"

import "./BusinessCooperation.vue?vue&type=style&index=0&id=07413408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07413408"]])

export default __exports__